import { IconDot } from '@/assets';
import HoverGridCanvas from '@/components/common/HoverGridCanvas';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionCompetitiveAdvantages = () => {
  const { t } = useTranslation();
  const competitiveAdvantages = [
    {
      number: '01',
      title: t('Innovative Technology Solutions'),
      desc: t('Possessing various technical capabilities in blockchain, AI, web/mobile, etc.'),
    },
    {
      number: '02',
      title: t('Customized Solutions'),
      desc: t(`Development perfectly tailored to customers' business models and requirements`),
    },
    {
      number: '03',
      title: t('Rapid Development Cycle'),
      desc: t('Quick development and deployment through agile methodology'),
    },
    {
      number: '04',
      title: t('Stability Guarantee'),
      desc: t('Enterprise-grade security and 99.9% system availability'),
    },
    {
      number: '05',
      title: t('Continuous Partnership'),
      desc: t('Providing maintenance and technical support even after development'),
    },
  ];
  return (
    <section className="competitive-advantages">
      <HoverGridCanvas />
      <div className="competitive-advantages__content">
        <p className="title">
          {t('Competitive')} <br /> {t('Advantages')}
        </p>
        <div className="list-items">
          {competitiveAdvantages.map((item, index) => (
            <div className="item" key={item.number}>
              <div className="item__top">
                <span className="number">{item.number}</span>
                <span className="title-item">{item.title}</span>
              </div>
              <div className="item__bottom">
                <div className="flex">
                  <div className="icon-dot">
                    <IconDot />
                  </div>
                  <span className="desc">{item.desc}</span>
                </div>
                <div className="icon-dot">
                  <IconDot />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(SectionCompetitiveAdvantages);
